import { render, staticRenderFns } from "./TodayArticle.vue?vue&type=template&id=1fc8d80f&"
import script from "./TodayArticle.vue?vue&type=script&lang=js&"
export * from "./TodayArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports